import avatar from './avatar.jpg'

const imgC = {
    avatar
}
export default imgC